export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/2935092e-5ec4-485e-b1db-609b8c1d9eff.png" 
                alt="GWDevelopers Logo — Web Development Nashville TN" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-gray-400 mb-4">
              AI-powered web development for Nashville small businesses. Serving Nashville, Franklin, Brentwood, East Nashville &amp; all of Middle Tennessee.
            </p>
            <div className="flex items-center gap-2 text-white mb-3">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-line text-sm"></i>
              </div>
              <span className="text-sm text-gray-400">Nashville, TN 37201</span>
            </div>
            <div className="flex items-center gap-2 text-white mb-3">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </div>
              <a href="tel:740-641-7292" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                740-641-7292
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase text-white font-semibold tracking-wider mb-4">Nashville Services</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Web Design Nashville
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Website Hosting Nashville
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Website Management Nashville
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  AI Web Development Nashville
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase text-white font-semibold tracking-wider mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase text-white font-semibold tracking-wider mb-4">Get Started</h4>
            <p className="text-sm text-gray-400 mb-4">
              Ready to launch your website? Request a free preview today.
            </p>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-white text-black text-sm font-semibold rounded-lg hover:bg-gray-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Request Preview
            </button>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} GWDevelopers. All rights reserved.
            </p>
            <p className="text-sm text-gray-500">
              Web Development Nashville, TN · AI-Powered Website Design · Serving Middle Tennessee
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}